module.exports = "/_next/static/images/OrchestrateAndOptimize@3x-a1013b7e8b57d991d07c3aa7252c37cd.webp";